import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/constant';

// 接口参数类型定义
export interface ProgressOverviewRequest {
  provinceId?: number;
  cityId?: number;
  countyId?: number;
  qlProvinceAgencyCode?: string;
  qlAreaCode?: string;
}

export interface EfficiencyOverviewRequest {
  provinceId?: number;
  cityId?: number;
  countyId?: number;
  qlProvinceAgencyCode?: string;
  qlAreaCode?: string;
}

export interface ProgressStageRequest {
  provinceId?: number;
  cityId?: number;
  countyId?: number;
  qlProvinceAgencyCode?: string;
  qlAreaCode?: string;
  dimension: 'day' | 'week' | 'month';
}

export interface EfficiencyStageRequest {
  provinceId?: number;
  cityId?: number;
  countyId?: number;
  qlProvinceAgencyCode?: string;
  qlAreaCode?: string;
  dimension: 'day' | 'week' | 'month';
}

export interface ProgressPageRequest {
  pageNum: number;
  pageSize: number;
  provinceId?: number;
  cityId?: number;
  countyId?: number;
  qlProvinceAgencyCode?: string;
  qlAreaCode?: string;
  deploymentStage?: string;
  expectedDeliveryTime?: string;
  deliveryCompleteStartTime?: string;
  deliveryCompleteEndTime?: string;
  stationNumber?: string[];
  orderNumber?: string;
}

export interface EfficiencyPageRequest {
  pageNum: number;
  pageSize: number;
  provinceId?: number;
  cityId?: number;
  countyId?: number;
  qlProvinceAgencyCode?: string;
  qlAreaCode?: string;
  expectedDeliveryTime?: string;
  deliveryDuration?: number;
  deliveryDurationSymbol?: 'gt' | 'lt' | 'eq';
  stationNumber?: string[];
  orderNumber?: string;
}

class DeployProcessMonitorApi {
  // 查询部署进度数据总览
  public async getProgressOverview(
    params: ProgressOverviewRequest,
  ): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/datacenter/web/deployment/get_progress_overview',
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  // 查询部署效率数据总览
  public async getEfficiencyOverview(
    params: EfficiencyOverviewRequest,
  ): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/datacenter/web/deployment/get_efficiency_overview',
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  // 查询部署进度阶段数据
  public async getProgressEveryStage(
    params: ProgressStageRequest,
  ): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/datacenter/web/deployment/get_progress_every_stage',
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  // 查询部署效率阶段数据
  public async getEfficiencyEveryStage(
    params: EfficiencyStageRequest,
  ): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/datacenter/web/deployment/get_efficiency_every_stage',
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  // 查询部署进度明细数据
  public async getProgressPageList(params: ProgressPageRequest): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/datacenter/web/deployment/get_progress_page_list',
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  // 查询部署效率明细数据
  public async getEfficiencyPageList(
    params: EfficiencyPageRequest,
  ): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/datacenter/web/deployment/get_efficiency_page_list',
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }
}

export const deployProcessMonitorApi = new DeployProcessMonitorApi();
